import React, { useEffect, useRef } from "react";
import { Spinner } from 'react-bootstrap';
import { isMobile } from "react-device-detect";
import QRCode from 'react-qr-code';
import config from '../configuration/config.json';
import axios from 'axios';

// Hands the selfie capture over to the mobile app (MegaMatcher ID SDK). The app captures the face and
// posts the SDK template to /neurotech/remote-verify (which enrolls the portrait); this page polls the outcome.

const POLL_INTERVAL_MS = 3000;

function parseBody(data) {
    return typeof data === 'string' && data !== '' ? JSON.parse(data) : data;
}

function NeurotechMobileVerify({ aid, cardType, onSuccess }) {
    const pollRef = useRef(null);

    const headers = {
        "content-type": "application/json",
        'Authorization': "Bearer " + config.idproofing.token
    };

    // The app enrolls the portrait and verifies through the API itself, so the link only identifies the
    // application. The phone gets an API address it can reach (not the browser's localhost).
    const mobileApiBaseUrl = config.idproofing.neurotech.mobileApiBaseUrl || config.idproofing.apibaseurl;
    const appLink = config.idproofing.neurotech.mobileAppLink
        .replace('{applicationId}', encodeURIComponent(aid))
        .replace('{cardType}', encodeURIComponent(cardType || ''))
        .replace('{apiBaseUrl}', encodeURIComponent(mobileApiBaseUrl));

    function stopPolling() {
        if (pollRef.current) {
            clearInterval(pollRef.current);
            pollRef.current = null;
        }
    }

    async function pollStatus() {
        try {
            const response = await axios.get(config.idproofing.apibaseurl + "idproofing/neurotech/status/" + aid, { headers: headers });
            const status = parseBody(response.data);
            if (status.verifyStatus !== 'COMPLETED') return;

            stopPolling();
            // Whatever the outcome, the verification page shows it (liveness and face match from /result).
            onSuccess();
        } catch (e) {
            // Transient network errors are retried on the next tick.
        }
    }

    useEffect(() => {
        pollRef.current = setInterval(pollStatus, POLL_INTERVAL_MS);
        return stopPolling;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aid]);

    return (
        <>
            <div className="row">
                <div className="col">
                    <span className="scaninstructiondisplay">
                        {isMobile ? "Open the goID app to take your selfie." : "Scan this QR code with your phone to take your selfie in the goID app."}
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="col m-4">
                    {isMobile ? (
                        <a className="btn btn-primary btn-lg px-4 gap-3" href={appLink}>
                            <span className="px-2">Open goID App</span>
                        </a>
                    ) : (
                        <QRCode size={256} style={{ maxWidth: 256, width: "100%" }} value={appLink} viewBox={`0 0 256 256`} />
                    )}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    <span className="px-2">Waiting for verification from the app...</span>
                </div>
            </div>
        </>
    );
}

export default NeurotechMobileVerify;
